import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ElevatedRealEstateStrategy() {
  return <section data-section-id="222933" id="industrial-excellence-showcase" className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background text-foreground">
      <div className="absolute inset-0 z-0">
        <div role="img" aria-label="ABCO South Electrical Construction and Design Industrial and Commercial electric and automation" className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_facility_wide.png)]" />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/30" />
      </div>

      <div className="relative z-10 flex w-full max-w-7xl flex-col items-center px-4 text-center">
        <h1 className="font-serif text-5xl font-normal leading-[0.85] tracking-tighter text-white sm:text-7xl lg:text-[120px]">
          Industrial & <br /> Commercial Excellence  
        </h1>

        <div className="mt-16 flex flex-col gap-6 sm:flex-row sm:gap-8">
          <Button asChild size="lg" className="h-16 rounded-md bg-primary px-12 text-lg font-default uppercase tracking-widest text-primary-foreground hover:bg-primary/90">
            <Link to="https://amusing-monitor.10web.cloud/services/">Our Services</Link>
          </Button>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 z-10 flex -translate-x-1/2 animate-pulse flex-col items-center gap-3 text-white">
        <ChevronDown className="size-6 opacity-80" />
      </div>
    </section>;
}